import React, { Component } from 'react';
import {API} from 'aws-amplify';
import utils from '../../util/index.js';
import MaintenanceMonitor from './maintenanceMonitor/maintenanceMonitor.js';
import './instanceControlPanel.css';

const {getSequenceData} = utils;

class InstanceControlPanel extends Component {

  state = {
    imageData: {},
    lastScreenshot: '',
    sX: 0,
    sY: 0,
    sWidth: 1024,
    sHeight: 768,
    refreshRate: this.props.preferences.defaultRefreshRate,
    timerId: '',
    refresh: true,
    debugLog: 'Attempting to acquire screenshot...',
    commandInfo: '',
    expanded: false,
    maintenanceData: {},
    allCommands: []
  }

  mounted = false;

  componentDidMount() {
    this.setState(JSON.parse(localStorage.getItem(`instanceControlPanel(${this.props.instance.InstanceId})_state`))); // STATE-UPDATE:
    this.mounted = true;
    this.getScreenshot();
    this.setState({refreshRate: this.props.preferences.defaultRefreshRate}); // STATE-UPDATE:
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {

    const {
      handleExpandMaintenance,
      handlePanelNavigation,
      handleRemoveFromMonitoring,
      handleChangeRefreshRate,
      iterateRefreshRate,
      pan,
      zoom,
    } = this;

    const {instance} = this.props;

    const {
      commandInfo,
      debugLog,
      expanded,
      lastScreenshot,
      refresh,
      refreshRate,
    } = this.state;

    return (
      <div className={`InstanceControlPanelContainer${expanded ? ' InstanceControlPanelContainerExpanded' : ''}`}>
        <div className="InstanceControlPanel">
          <div className="TopPane">
            <div className="InstanceInformation">
              <p>{instance.InstanceId}</p>
              <p>{instance.name}</p>
              <p>{instance.accountName}</p>
              <p>{instance.role}</p>
            </div>
            <div className="TopRightControls">
              <div className="NavAndCloseControls">
                <button className="NavButton" onClick={handlePanelNavigation}>{'<<'}</button>
                <button className="NavButton" onClick={handlePanelNavigation}>{'>>'}</button>
                <div className="EmptyDiv"></div>
                <button className="CloseButton" onClick={handleRemoveFromMonitoring}>X</button>
              </div>
              <p>Refresh Rate (seconds):</p>
              <div className="RefreshControls">
                <button onClick={() => iterateRefreshRate(-1)}>-</button>
                <input id="RefreshInput" value={refreshRate} onChange={handleChangeRefreshRate}></input>
                <button onClick={() => iterateRefreshRate(1)}>+</button>
              </div>
            </div>
          </div>
          <div className="BottomPane">
            <div className="PanZoomControls">
              <button onClick={() => zoom('out')}>-</button>
              <button onClick={() => pan('up')}>^</button>
              <button onClick={() => zoom('in')}>+</button>
              <br/>
              <button onClick={() => pan('left')}>{'<'}</button>
              <button onClick={() => pan('down')}>v</button>
              <button onClick={() => pan('right')}>></button>
              <br/>
              <button onClick={handleExpandMaintenance}>M</button>
            </div>
            <span className={`refreshIndicator${debugLog !== 'Screenshot successfully obtained.' ? ' failedRefresh' : ''}${refresh ? '' : ' refreshIndicatorAnimate'}`}></span>
            <canvas id={`canvas${instance.InstanceId}`} height="300" width="400" onClick={() => iterateRefreshRate(0)}></canvas>
            <p className="ScreenshotTimeB">{lastScreenshot}</p>
            <p className="ScreenshotTime">{lastScreenshot}</p>
            <p className="LiveIndicatorB">{debugLog !== 'Screenshot successfully obtained.' ? 'NOT LIVE' : 'LIVE'}</p>
            <p className={`LiveIndicator${debugLog !== 'Screenshot successfully obtained.' ? ' NOTLIVE' : ''}`}>{debugLog !== 'Screenshot successfully obtained.' ? 'NOT LIVE' : 'LIVE'}</p>
            {commandInfo !== '' && <p className="Command">{`> ${commandInfo}`}</p>}
            {commandInfo !== '' && <p className="CommandRunningB">{'COMMAND(S) RUNNING'}</p>}
            {commandInfo !== '' && <p className="CommandRunningW">{'COMMAND(S) RUNNING'}</p>}
            <p className="DebugLog">{`> ${debugLog}`}</p>
          </div>
        </div>
        {this.state.expanded && <MaintenanceMonitor maintenanceData={this.state.maintenanceData} updateMaintenanceData={this.updateMaintenanceData} allCommands={this.state.allCommands}/>}
      </div>
    );
  }

  updateMaintenanceData = async () => {
    const sequence = await getSequenceData(this.props.instance.InstanceId);
    const newMaintenanceData = {sequence};
    this.setState({maintenanceData: newMaintenanceData}); // STATE-UPDATE:
  }

  handleExpandMaintenance = () => {
    this.setState({expanded: !this.state.expanded}); // STATE-UPDATE:
  };

  handlePanelNavigation = e => {
    this.props.reorderMonitoring(this.props.instance.InstanceId, e.target.innerText);
    this.saveToLocalStorage();
  }

  handleChangeRefreshRate = e => {
    let refreshRate = Math.round(e.target.value);
    if (refreshRate < 5) refreshRate = 5;
    this.setState({refreshRate}, () => { // STATE-UPDATE:
      clearTimeout(this.state.timerId);
      const timerId = setTimeout(this.getScreenshot, 1000);
      this.setState({timerId}); // STATE-UPDATE:
      this.saveToLocalStorage();
    });
  }

  iterateRefreshRate = dir => {
    const refreshRate = parseInt(this.state.refreshRate, 10) + dir;
    this.handleChangeRefreshRate({target: {value: refreshRate}});
  }

  saveToLocalStorage = () => {

    const storeData = {...this.state};
    delete storeData.imageData;

    localStorage.setItem(`instanceControlPanel(${this.props.instance.InstanceId})_state`, JSON.stringify(storeData));

  }

  handleRemoveFromMonitoring = () => {
    this.setState({mounted: false}, () => { // STATE-UPDATE:
      if (this.state.intervalId) clearInterval(this.state.intervalId);
      this.props.removeFromMonitoring(this.props.instance);
    });

    if (this.state.intervalId) clearInterval(this.state.intervalId);
    this.props.removeFromMonitoring(this.props.instance);
  }

  getScreenshot = () => {

    clearTimeout(this.state.timerId);

    if (this.mounted) {

      API.get('WBU', '/runningcommands', {
        queryStringParameters: {
          instanceId: this.props.instance.InstanceId,
          accountId: this.props.instance.accountId,
          getAll: true
        }
      })
      .then(CommandInvocations => {
        if (CommandInvocations[0] && ['InProgress', 'Cancelling'].includes(CommandInvocations[0].Status)) {
          this.setState({commandInfo: CommandInvocations[0].Comment || 'No comment available'}); // STATE-UPDATE:
        } else {
          this.setState({commandInfo: ''}); // STATE-UPDATE:
        }
        this.setState({allCommands: [...CommandInvocations]}); // STATE-UPDATE:
      })
      .catch(err => {
        // console.log(err);
      });

      setTimeout(() => {
        API.get('WBU', '/instancescreenshot', {
          queryStringParameters: {
            instanceId: this.props.instance.InstanceId,
            accountId: this.props.instance.accountId,
            region: this.props.instance.region
          }
        })
        .then(imageData => {

          if (this.mounted) {

            this.drawScreenshot(imageData);

            if (imageData.err) {

              this.setState({ // STATE-UPDATE:
                refresh: true,
                debugLog: imageData.err
              }, () => {
                setTimeout(() => {
                  this.setState({refresh: false}); // STATE-UPDATE:
                }, 0);
              });

            } else {

              this.setState({ // STATE-UPDATE:
                lastScreenshot: new Date(Date.now()).toLocaleString(),
                imageData: imageData,
                refresh: true,
                debugLog: 'Screenshot successfully obtained.'
              }, () => {
                setTimeout(() => {
                  this.setState({refresh: false}); // STATE-UPDATE:
                }, 0);
              });

            }

          }

        })
        .catch(err => {
          console.log(err);
        });
      }, 0);

      let timerId;

      if (this.mounted) timerId = setTimeout(this.getScreenshot, this.state.refreshRate * 1000);

      this.setState({timerId}); // STATE-UPDATE:

    }

  }

  drawScreenshot = imageData => {

    //This function draws the screenshot stored in state.
    const {instance} = this.props;
    const {sX, sY, sWidth, sHeight} = this.state;

    if (!imageData) imageData = this.state.imageData;

    const canvas = document.getElementById(`canvas${instance.InstanceId}`);
    const ctx = canvas.getContext('2d');
    if (imageData.imageData) {
      const screenShot = new Image(0, 0);
      screenShot.src = `data:image/jpeg;base64,${imageData.imageData}`;
      setTimeout(() => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(screenShot, sX, sY, sWidth, sHeight, 0, 0, 400, 300);
      }, 0);
    } else if (!this.state.lastScreenshot) {
      ctx.beginPath();
      ctx.rect(0, 0, 400, 300);
      ctx.fillStyle = 'black';
      ctx.fill();
      ctx.font = '30px Calibri';
      ctx.fillStyle = 'white';
      ctx.fillText('No Screenshot Available', 50, 170);

      this.setState({ // STATE-UPDATE:
        lastScreenshot: new Date(Date.now()).toLocaleString(),
      });

    }

  }

  zoom = dir => {

    let {sX, sY, sWidth, sHeight} = this.state;

    const f = 10;

    if (dir === 'in') {
      sX += 4 * f;
      sY += 3 * f;
      sWidth -= 8 * f;
      sHeight -= 6 * f;
    } else {
      sX -= 4 * f;
      sY -= 3 * f;
      sWidth += 8 * f;
      sHeight += 6 * f;
    }

    if (sWidth > 0 && sHeight > 0) {
      this.setState({sX, sY, sWidth, sHeight}, () => { // STATE-UPDATE:
        this.saveToLocalStorage();
        this.drawScreenshot();
      });
    }

  }

  pan = dir => {

    const inverted = this.props.preferences.invertNavControls;

    let {sX, sY, sWidth, sHeight} = this.state;

    const f = 10;

    if (dir === 'up') {
      inverted ? sY += 3 * f : sY -= 3 * f;
    } else if (dir === 'down') {
      inverted ? sY -= 3 * f : sY += 3 * f;
    } else if (dir === 'left') {
      inverted ? sX += 4 * f : sX -= 4 * f;
    } else {
      inverted ? sX -= 4 * f : sX += 4 * f;
    }

    this.setState({sX, sY, sWidth, sHeight}, () => { // STATE-UPDATE:
      this.saveToLocalStorage();
      this.drawScreenshot();
    });

  }

}

export default InstanceControlPanel;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/instances/instanceControlPanel/instanceControlPanel.js